import React from 'react';

const DemoCredentials = () => {
  const copyToClipboard = (text) => {
    navigator?.clipboard?.writeText(text)?.then(() => {
      // Optional: Show a brief success message
    })?.catch(() => {
      // Fallback for older browsers
      const textArea = document.createElement('textarea');
      textArea.value = text;
      document.body?.appendChild(textArea);
      textArea?.select();
      document.execCommand('copy');
      document.body?.removeChild(textArea);
    });
  };

  return (
    <div className="mt-6 p-4 bg-blue-50 rounded-lg border border-blue-200">
      <h4 className="text-sm font-medium text-blue-900 mb-3">Credenziali di Accesso</h4>
      <div className="space-y-3 text-sm">
        <div className="bg-white rounded border p-3">
          <p className="text-xs font-semibold uppercase tracking-wide text-blue-800 mb-3">
            Amministrazione
          </p>
          <div className="space-y-2">
            <div className="flex items-center justify-between gap-3">
              <span className="text-gray-700">
                <strong>User:</strong> admin
              </span>
              <button
                onClick={() => copyToClipboard('admin')}
                className="text-blue-600 hover:text-blue-800 text-xs px-2 py-1 rounded bg-blue-100 hover:bg-blue-200"
                title="Copia user amministrazione"
              >
                Copia user
              </button>
            </div>
            <div className="flex items-center justify-between gap-3">
              <span className="text-gray-700">
                <strong>Password:</strong> demo123
              </span>
              <button
                onClick={() => copyToClipboard('demo123')}
                className="text-blue-600 hover:text-blue-800 text-xs px-2 py-1 rounded bg-blue-100 hover:bg-blue-200"
                title="Copia password amministrazione"
              >
                Copia password
              </button>
            </div>
          </div>
        </div>
        <div className="bg-white rounded border p-3">
          <p className="text-xs font-semibold uppercase tracking-wide text-blue-800 mb-3">
            Venditore
          </p>
          <div className="space-y-2">
            <div className="flex items-center justify-between gap-3">
              <span className="text-gray-700">
                <strong>User:</strong> venditore
              </span>
              <button
                onClick={() => copyToClipboard('venditore')}
                className="text-blue-600 hover:text-blue-800 text-xs px-2 py-1 rounded bg-blue-100 hover:bg-blue-200"
                title="Copia user venditore"
              >
                Copia user
              </button>
            </div>
            <div className="flex items-center justify-between gap-3">
              <span className="text-gray-700">
                <strong>Password:</strong> demo123
              </span>
              <button
                onClick={() => copyToClipboard('demo123')}
                className="text-blue-600 hover:text-blue-800 text-xs px-2 py-1 rounded bg-blue-100 hover:bg-blue-200"
                title="Copia password venditore"
              >
                Copia password
              </button>
            </div>
          </div>
        </div>
      </div>
      <p className="text-xs text-blue-600 mt-2">
        Usa queste credenziali per entrare subito nel sistema.
      </p>
    </div>
  );
};

export default DemoCredentials;
